var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "settings-editor-base",
    { attrs: { label: _vm.label } },
    [
      [
        _c("i", {
          staticClass: "fa fa-2x fa-undo icon",
          attrs: {
            "aria-hidden": "true",
            "data-toggle": "tooltip",
            title: _vm.tooltips.settingsRotationLeftTooltip
          },
          on: {
            click: function($event) {
              return _vm.rotate(-90)
            }
          }
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-2x fa-repeat icon",
          attrs: {
            "aria-hidden": "true",
            "data-toggle": "tooltip",
            title: _vm.tooltips.settingsRotationRightTooltip
          },
          on: {
            click: function($event) {
              return _vm.rotate(90)
            }
          }
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }